import Layout from 'features/shared/components/layout/Layout';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from 'features/shared/components/common/ScrollToTop';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <AppRoutes />
      </Layout>
    </>
  );
}